import { useRoute, useRuntimeConfig } from "#imports";
import { computed, ref, nextTick, onMounted, watch, watchEffect } from "vue";
import { useCurrentElement } from "@vueuse/core";
import { defu } from "defu";
export function useAdsense(input) {
  const config = useRuntimeConfig().public.googleAdsense;
  const options = defu(input, config);
  const adClient = options.adClient ?? options.id;
  const adTest = options.test ? "on" : null;
  const key = Math.random();
  const ad = useCurrentElement();
  const adClass = ref("");
  const show = ref(false);
  const adRegion = computed(() => show.value ? `page-${Math.random()}` : null);
  const isUnfilled = computed(() => ad.value?.getAttribute("data-ad-status") === "unfilled");
  const path = useRouteAttr("path");
  const queryParams = useRouteAttr("query");
  const status = computed(() => show.value ? null : "");
  async function updateAd() {
    if (process.server)
      return;
    show.value = false;
    await nextTick();
    showAd();
  }
  async function showAd() {
    show.value = true;
    await nextTick();
    if (ad.value?.innerHTML)
      return;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (error) {
      console.error(error);
    }
  }
  watch([path, queryParams], (newRoute, oldRoute) => {
    const routeChanged = hasRouteChanged(newRoute, oldRoute, options.includeQuery);
    if (ad.value && !ad.value.isConnected)
      return;
    if (!routeChanged)
      return;
    updateAd();
  });
  watchEffect(() => {
    if (!ad.value || !ad.value.isConnected)
      return;
    if (show.value)
      ad.value.innerHTML = "";
    else
      ad.value.innerHTML = " ";
  });
  if (options.hideUnfilled) {
    watchEffect(() => isUnfilled.value && (adClass.value = "hide-unfilled"));
  }
  onMounted(() => showAd());
  return {
    // computed properties
    adClass,
    dataAdClient: adClient,
    dataAdRegion: adRegion,
    dataAdTest: adTest,
    dataAnalyticsDomainName: options.analyticsDomainName,
    dataAnalyticsUacct: options.analyticsUacct,
    isUnfilled,
    key,
    status,
    // methods
    updateAd,
    showAd
  };
}
function useRouteAttr(name) {
  const route = useRoute();
  return computed(() => route[name]);
}
function hasRouteChanged(newRoute, oldRoute, includeQuery) {
  const [newPath, newQuery] = newRoute;
  const [oldPath, oldQuery] = oldRoute;
  if (newPath !== oldPath)
    return true;
  if (!includeQuery)
    return;
  const newQueryKeys = Object.keys(newQuery);
  const oldQueryKeys = Object.keys(oldQuery);
  return newQueryKeys.length !== oldQueryKeys.length || newQueryKeys.some((key) => newQuery[key] !== oldQuery[key]);
}
